import React, { ReactElement, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { FaExchangeAlt, FaList, FaTruck, FaBoxOpen } from 'react-icons/fa';
import { GoChecklist } from 'react-icons/go';

import { Container, CardContainer, Card } from './styles';

import { useAuth } from '../../hooks/auth';
import ModalChangeStatusFila from '../../components/ModalChangeStatusFila';
import {
  RiGuideLine,
  RiUserFollowLine,
  RiPrinterLine,
  RiListOrdered,
} from 'react-icons/ri';
import ModalChegadaMotoristas from '../../components/ModalChegadaMotoristas';
import api from '../../services/api';
import ModalTodoChecklist from '../../components/Modals/ModalTodoChecklist';
import ModalPrintChecklist from '../../components/Modals/ModalPrintChecklist';
import ModalOperationsReport from '../../components/Modals/ModalOperationsReport';

function PainelLogistica(): ReactElement {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const [changeStatusModalOpen, setChangeStatusModalOpen] = useState(false);
  const [chegadaMotoristaModalOpen, setChegadaMotoristaModalOpen] =
    useState(false);

  const [filaCarregamento, setFilaCarregamento] = useState([]);

  const [todoChecklistModalOpen, setTodoChecklistModalOpen] = useState(false);

  const [printChecklistModalOpen, setPrintChecklistModalOpen] = useState(false);

  const [operationsReportModalOpen, setOperationsReportModalOpen] =
    useState(false);

  // Toogle modal change status
  function toogleChangeStatusModal(): void {
    setChangeStatusModalOpen(!changeStatusModalOpen);
  }

  // Toogle modal Chegada Motorista,
  function toogleInsertChegadaMotorista(): void {
    setChegadaMotoristaModalOpen(!chegadaMotoristaModalOpen);
  }

  // Toogle Todo Checklist Modal - Faz checklist
  async function togleTodoChecklist(): Promise<void> {
    // Find fila carregamento
    const foundFilaCarregamento = await api.get('/fila/').then(response => {
      const filteredFila = response.data.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (fila: any) => fila.status === 'ACKL',
      );
      return filteredFila;
    });
    setFilaCarregamento(foundFilaCarregamento);
    setTodoChecklistModalOpen(!todoChecklistModalOpen);
  }

  function toglePrintChecklist(): void {
    setPrintChecklistModalOpen(!printChecklistModalOpen);
  }

  function toggleOperationsReport(): void {
    setOperationsReportModalOpen(!operationsReportModalOpen);
  }

  let user = localStorage.getItem('@Bsa:user');
  if (!user) {
    user = '';
  }
  const userObj = JSON.parse(user);

  const isPortariaUser =
    userObj.logistica === true &&
    (userObj.avatar === 'portaria' ||
      userObj.login === 'portaria@bsabioenergia.com.br');

  return (
    <Container>
      <ModalChangeStatusFila
        isOpen={changeStatusModalOpen}
        setIsOpen={() => toogleChangeStatusModal()}
      />

      <ModalChegadaMotoristas
        isOpen={chegadaMotoristaModalOpen}
        setIsOpen={() => toogleInsertChegadaMotorista()}
      />

      <ModalTodoChecklist
        isOpen={todoChecklistModalOpen}
        setIsOpen={() => togleTodoChecklist()}
        filaData={filaCarregamento}
      />

      <ModalPrintChecklist
        isOpen={printChecklistModalOpen}
        setIsOpen={() => toglePrintChecklist()}
      />

      <ModalOperationsReport
        isOpen={operationsReportModalOpen}
        setIsOpen={() => toggleOperationsReport()}
      />

      <header>
        <h1>Bom Sucesso Agroindústria S.A</h1>

        <nav>
          <button type="submit" onClick={() => navigate('/')}>
            Página Inicial
          </button>

          <button type="submit" onClick={() => navigate('/admin')}>
            Voltar
          </button>

          <button type="submit" onClick={signOut}>
            Logout
          </button>
        </nav>
      </header>
      <h2 id="pageTitle">Painel Logística</h2>

      <h2 id="selectOption">Selecione uma opção</h2>

      <CardContainer style={{ display: isPortariaUser ? 'flex' : 'grid' }}>
        {isPortariaUser ? (
          <>
            {/* Confirmar Motorista */}
            <Card onClick={() => toogleInsertChegadaMotorista()}>
              <h1
                className="cadConfirmaMotorista"
                id="cadConfirmaMotorista"
                data-testid="cadConfirmaMotorista"
              >
                Confirmar Motorista
              </h1>
              <RiUserFollowLine size={42} color="#fff" />
            </Card>
            {/* Agendamentos Card - only accessible to user.logistica */}
            <Card onClick={() => navigate('/painelagendamentos')}>
              <h1
                className="painelAgendamentos"
                data-testid="painelAgendamentos"
              >
                Agendamentos
              </h1>
              <FaList size={42} color="#fff" />
            </Card>
          </>
        ) : (
          <>
            {/* Confirmar Motorista */}
            <Card onClick={() => toogleInsertChegadaMotorista()}>
              <h1
                className="cadConfirmaMotorista"
                id="cadConfirmaMotorista"
                data-testid="cadConfirmaMotorista"
              >
                Confirmar Motorista
              </h1>
              <RiUserFollowLine size={42} color="#fff" />
            </Card>

            {/* Change Status */}
            <Card onClick={() => toogleChangeStatusModal()}>
              <h1 className="painelLogistica" data-testid="painelLogistica">
                Altera Status Fila
              </h1>
              <FaExchangeAlt size={42} color="#fff" />
            </Card>

            {/* Agendamentos Card - only accessible to user.logistica */}
            <Card onClick={() => navigate('/painelagendamentos')}>
              <h1
                className="painelAgendamentos"
                data-testid="painelAgendamentos"
              >
                Agendamentos
              </h1>
              <FaList size={42} color="#fff" />
            </Card>

            {/* Carregamentos Card - only accessible to user.logistica */}
            <Card onClick={() => navigate('/painelcarregamentos')}>
              <h1
                className="painelCarregamentos"
                data-testid="painelCarregamentos"
              >
                Carregamentos
              </h1>
              <FaTruck size={42} color="#fff" />
            </Card>

            {/* Carregamentos Overview Card - only accessible to user.logistica */}
            <Card onClick={() => navigate('/carregamentosoverview')}>
              <h1
                className="carregamentosOverview"
                data-testid="carregamentosOverview"
              >
                Overview Carregamentos
              </h1>
              <FaBoxOpen size={42} color="#fff" />
            </Card>

            {/* Saldo ordens SAP */}
            <Card onClick={() => navigate('/saldoordenssap')}>
              <h1
                className="saldoOrdensSap"
                id="saldoOrdensSap"
                data-testid="saldoOrdensSap"
              >
                Saldo Ordens SAP
              </h1>
              <RiGuideLine size={42} color="#fff" />
            </Card>

            {/* Checklist */}
            <Card onClick={() => togleTodoChecklist()}>
              <h1 className="checklist" id="checklist" data-testid="checklist">
                Checklist
              </h1>
              <GoChecklist size={42} color="#fff" />
            </Card>

            {/* Print Checklist */}
            <Card onClick={() => toglePrintChecklist()}>
              <h1
                className="print-checklist"
                id="print-checklist"
                data-testid="print-checklist"
              >
                Impressão Checklist
              </h1>
              <RiPrinterLine size={42} color="#fff" />
            </Card>

            {/* Operations Report */}
            <Card onClick={() => toggleOperationsReport()}>
              <h1
                className="operations-report"
                id="operations-report"
                data-testid="operations-report"
              >
                Relatório Operação
              </h1>
              <RiListOrdered size={42} color="#fff" />
            </Card>
          </>
        )}
      </CardContainer>
    </Container>
  );
}

export default PainelLogistica;
